import { CardSection } from "./common/Card";
import { useState } from "react";
import {Alert} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { DateRangePicker } from "./common/DateRangePicker";

import {ISODateRange} from "../ISODateRange";
import {DownloadCSVButton} from "./common/SubmitButton";
import { Result } from "../client/Result";
import {Select, SelectOption} from "./common/MuiSelect";


interface EMRSMeteredVolumesDownloadProps {
    download: (range: ISODateRange, bucketId: string) => Promise<Result<void>>
    className?: string
    cmuIds: string[]
}

export const EMRSMeteredVolumesDownload = ({ download, className, cmuIds }: EMRSMeteredVolumesDownloadProps) => {
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [bucket, setBucket] = useState('')
    const [dateRangeValid, setDateRangeValid] = useState(false)
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>()

    async function handleSubmit(event) {

        const form = event.currentTarget
        setErrorMessage(undefined)
        event.preventDefault()
        setValidated(true)
        if (form.checkValidity() === true && dateRangeValid) {
            const submissionResult = await download(new ISODateRange(startDate,  endDate), bucket)
            submissionResult.fold(
                ()  => undefined,
                err => setErrorMessage(`An error occurred - #ask-tech for support. ${err}`)
            )
        } else {
            form.reportValidity()
        }
    }

    return <CardSection className={className} header={'EMRS Metered Volumes'} as="h6">
        <Form noValidate validated={validated} >
            <Select className='mb-3' label='CmuId' data-testid={'hhConsElexonDsrCert_bucket'} initialValue={{ id: bucket, label: bucket}}
                    onChange={(e:SelectOption) => {
                        setErrorMessage(undefined)
                        setBucket(e.id)
                    }}
                    options={cmuIds.map(b => ({ id: b, label: b}))} />

            <DateRangePicker start={startDate} end={endDate}
                             onEndChange={(end) => setEndDate((end))}
                             onStartChange={(start) => setStartDate(start)}
                             setErrorMessage={error => (setErrorMessage(error))}
                             reportIsValid={valid => setDateRangeValid(valid)}
                             testId='hhConsElexonDsrCert'
            />

            <DownloadCSVButton dataTestId='hhConsElexonDsrCert_download'
                disabled={!(startDate && endDate && (startDate <= endDate) && bucket)}
                onSubmit={handleSubmit}/>
            {errorMessage &&
                <Alert data-testid='errorMessage' variant='danger'>{errorMessage}</Alert>}
        </Form>
    </CardSection>
}
